<template>
    <div class="page-content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                        <div>
                            <h4 class="">{{detail.courses}}</h4>
                            <h5 class="mb-sm-0">{{detail.topic}}</h5>
                        </div>

                        <div class="page-title-right">
                            <ol class="breadcrumb m-0">
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name: 'dashboard_teacher' }">Dashboard</router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name: 'courses_teacher' }">Kelas Online</router-link>
                                </li>
                                <li class="breadcrumb-item active">Daftar Pembelajaran</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <div class="d-block">
                                    <ul class="nav nav-pills" role="tablist">
                                        <li class="nav-item waves-effect waves-light" @click="changeTab('question')">
                                            <a class="nav-link active" data-bs-toggle="tab" role="tab">
                                                <i class="dripicons-list me-1 align-middle"></i> <span class="d-none d-md-inline-block">Daftar Soal</span> 
                                            </a>
                                        </li>
                                        <li class="nav-item waves-effect waves-light" @click="changeTab('result')">
                                            <a class="nav-link" data-bs-toggle="tab" role="tab">
                                                <i class="dripicons-clipboard font-size-18 me-1 align-middle"></i> <span class="d-none d-md-inline-block">Hasil Kuis</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="d-block">
                                    <router-link class="btn btn-light" :to="{name: 'manage_lessons', params: {id: $route.params.courses_id}}">Kembali</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 grid-margin stretch-card">
                <!-- <keep-alive> -->
                <component :is="currentTabComponent"></component>
                <!-- </keep-alive> -->
            </div>
        </div>
    </div>
</template>
<script>
// import tab components
import question from '@/views/teacher/courses/quiz/tabs/Question.vue';
import result from '@/views/teacher/courses/quiz/tabs/ResultQuiz.vue';

export default {
    name: 'CoursesDetail',
    metaInfo: {
        title: "Daftar Pembelajaran",
        titleTemplate: "%s - Elearning"
    },
    components: {
        question, result
    },
    data() {
        return {
            detail: {},
            currentTabComponent: 'question'
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        changeTab: function(tabs) {
            this.currentTabComponent = tabs;
        },
        getData: function () {
            let uri = process.env.VUE_APP_APIHOST + 'teacher/lessons/detail';

            this.$http.get(uri, { params: {id: this.$route.params.id} }).then(res => {
                if (res.data.status)
                    this.detail = res.data.data;
            });
        },
    },
}
</script>